import { createRoute } from '@tanstack/react-router'
import { projectRoute } from '../route'
import { redirectLegacyMembers } from '@/components/settings/legacy-redirects'

/** Old members page → the settings dialog on Medlemmar (board h39z). */
export const membersRedirectRoute = createRoute({
  getParentRoute: () => projectRoute,
  path: '/members/',
  beforeLoad: redirectLegacyMembers,
  component: () => null,
})
